import React, { useState } from 'react';
import { useLocale } from 'locale';
import { IDeveloperStaff } from 'utils/entities';
import { ShowAt, useScreenBreakpoint } from 'consts/breakpoints';
import { MemberCard } from 'screens/DeveloperPage/components/members/MemberCard';
import { ScrollBox } from 'ds/components/carousels/scroll-box';
import { SectionTitle } from 'screens/DeveloperPage/styled';
import * as Styled from './styled';

const MEMBERS_COLLAPSED_LIMIT = 6;

const Members: React.FC<{ data: IDeveloperStaff[]; }> = ({ data }) => {
  const { t } = useLocale();

  if (!data || !data.length) return null;

  const [ isCollapsed, setIsCollapsed ] = useState(data.length > MEMBERS_COLLAPSED_LIMIT);
  const breakpoint = useScreenBreakpoint();
  const isMobile = breakpoint <= 2;
  const isCollapsible = !isMobile && data.length > MEMBERS_COLLAPSED_LIMIT;

  const mapMembersToCardList = (members: IDeveloperStaff[]) =>
    members.map((member, index) => <MemberCard member={member} key={index} />);

  const list = isCollapsible && isCollapsed
    ? mapMembersToCardList(data.slice(0, MEMBERS_COLLAPSED_LIMIT))
    : mapMembersToCardList(data);

  return (
    <Styled.Root>
      <SectionTitle>{t('developerPage.members.title')}</SectionTitle>
      <ShowAt from={3}>
        <Styled.MembersWrapper data-auto="Developer-members-cards">{list}</Styled.MembersWrapper>
        {isCollapsible &&
          <Styled.ToggleVisibility
            onClick={() => setIsCollapsed(!isCollapsed)}
            isCollapsed={isCollapsed}
          >
            {isCollapsed ? t('developerPage.members.showAll') : t('developerPage.members.showLess')}
          </Styled.ToggleVisibility>
        }
      </ShowAt>
      <ShowAt to={2}>
        <Styled.MembersWrapper>
          <ScrollBox autoWidth>
            {list}
          </ScrollBox>
        </Styled.MembersWrapper>
      </ShowAt>
    </Styled.Root>
  );
};
export default React.memo(Members);
